import { ChartConfiguration, ChartData } from 'chart.js';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';

// #region     BEGIN OPTIONS
const defaultChartOptions = (): ChartConfiguration['options'] => ({
  scales: {
    x: {
      grid: {
        display: true,
      },
      ticks: {
        color: '#999999',
        font: {
          size: 12,
        },
      },
    },
    y: {
      beginAtZero: true,
      grid: {
        display: true,
      },
      ticks: {
        stepSize: 1,
        padding: 20,
        color: '#999999',
        font: {
          size: 12,
        },
      },
    },
  },
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
  },
});
// #endregion  END OPTIONS

// #region     BEGIN DATA
const defaultChartData = (): ChartData<'line'> => ({
  labels: [],
  datasets: [
    {
      data: [], // Values ​​for the graph
      label: '',
      borderColor: '#8781FF',
      backgroundColor: 'rgba(135, 129, 255, 0.12)',
      pointBackgroundColor: '#8781FF',
      pointBorderColor: '#8781FF',
      pointHoverBackgroundColor: '#8781FF',
      pointHoverBorderColor: '#8781FF',
      pointRadius: 5,
      pointHoverRadius: 6,
      borderWidth: 3,
      fill: true, // For shading below the line
      tension: 0.4, // Smoothing the line
    },
  ],
});
// #endregion  END DATA

// #region     BEGIN PLUGINS
const defaultChartPlugins = (): any[] => [DataLabelsPlugin];
// #endregion  END PLUGINS

export const chartDefaults = Object.freeze({
  plugins: defaultChartPlugins,
  options: defaultChartOptions,
  data: defaultChartData,
});
